import React from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
function PayerTable({ tableData }) {
  const navigate = useNavigate();
  const handleEditClick = (id) => {
    //alert(id);
    navigate(`/home/payer/edit/${id}`);
  };
  return (
    <Table striped bordered hover className="tbl-require">
      <thead>
        <tr>
          <th>#</th>
          <th>Payor Name</th>
          <th style={{ textAlign: "center" }}>Action</th>
        </tr>
      </thead>
      <tbody>
        {tableData &&
          tableData.map((details, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{details.payer_name}</td>

              <td style={{ textAlign: "center", cursor: "pointer" }}>
                <i
                  className="pi pi-pen-to-square icon-btn-edit"
                  onClick={() => handleEditClick(details.id)}
                ></i>
                <i className="pi pi-trash icon-btn-delete"></i>
              </td>
            </tr>
          ))}
      </tbody>
    </Table>
  );
}

export default PayerTable;
